import { useEffect } from 'react';
import WebCityEdit from './WebCityEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { getColumnsheadId } from '../../universal/columnshead';
import { Tooltip } from 'antd';

const WebUniversalList = (props: any) => {

    useEffect(() => {
        //同步获取数据 async - await

        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //表头
    const columnsHead = [
        {
            title: '省',
            dataIndex: 'province',
            render: (text: any) => (
                <Tooltip placement="topLeft" title={text ?
                    text.countryOrArea.countryOrAreaName
                    : ''}>
                    {text ? text.provinceName : ''}
                </Tooltip>
            )
        },
        {
            title: '城市名称',
            dataIndex: 'cityName',
        },
        {
            title: 'usName',
            dataIndex: 'usName',
        },
        {
            title: '区号',
            dataIndex: 'cityNumber',
        },
    ];

    const columns = getColumnsheadId({ title: '代码', dataIndex: 'code' })
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '城市',
        apiId: 'webCity',
        columns,
        showStates: true,
        primaryKeyName: 'code',
        EditComponent: WebCityEdit,
    };

    return (
        <>
            <WebUniversal props={extendProps} />
        </>
    )
}

export default WebUniversalList;